export default {"src":"/_next/static/media/thumbs-up.c917d408.svg","height":43,"width":44};